import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';
import {useHistory} from 'react-router-dom';

import {IconWithTooltip, IconInfoCircle} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {ArgosStatus, getArgosJobStatusChipColor} from '@utils/tableHelpers';

export const JobStatusLabel = ({jobUuid, liveJob, message, state, eventId, jobId}) => {
    const history = useHistory();
    const handleHistoryClick = (e) => {
        e.stopPropagation();
        history.push(getLink('events.argosJobs.jobHistory', {id: eventId, argosJobId: jobId}));
    };

    const status = liveJob?.status?.state ?? state;

    const statusLower = status?.toLowerCase();

    const messageIcon = message
        ? <IconInfoCircle tooltip={message} iconProps={{color: 'blue'}} />
        : null;

    if (!status || !jobUuid) {
        return (
            <span className='job-status-label'>
                <span className='job-status-label__text'>Not started</span>
                {messageIcon}
            </span>
        );
    }

    const statusChip = (
        <ArgosStatus
            label={status.replaceAll('_', ' ')}
            color={getArgosJobStatusChipColor(statusLower)}
        />
    );

    const exitCode = liveJob?.status?.code;
    const exitCodeDescription = liveJob?.status?.description;
    const hasExitCodeIssue = (null != exitCode && 0 !== exitCode)
        || (null != exitCodeDescription && '' !== exitCodeDescription);

    const chipWithTooltip = hasExitCodeIssue ? (
        <Popup
            content={(
                <div className='argos-exit-code-tooltip'>
                    <div>{`Exit code: ${exitCode ?? '-'}`}</div>
                    <div>{`Exit code description: ${exitCodeDescription ?? '-'}`}</div>
                </div>
            )}
            trigger={<span>{statusChip}</span>}
            position='top center'
            hoverable
        />
    ) : statusChip;

    const hasJobHistory = liveJob?.job_history && 0 < liveJob.job_history.length;
    const historyIcon = hasJobHistory ? (
        <IconWithTooltip
            iconProps={{
                className: 'job-history-icon outline',
                onClick: handleHistoryClick,
                style: {cursor: 'pointer'},
            }}
            name='file alternate outline'
            tooltip='Job history'
        />
    ) : null;

    return (
        <span className='job-status-label'>
            {chipWithTooltip}
            {historyIcon}
            {messageIcon}
        </span>
    );
};

JobStatusLabel.propTypes = {
    jobUuid: PropTypes.string,
    liveJob: PropTypes.shape({
        status: PropTypes.shape({
            state: PropTypes.string,
            code: PropTypes.number,
            description: PropTypes.string,
        }),
        job_history: PropTypes.array,
    }),
    message: PropTypes.string,
    state: PropTypes.string,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default JobStatusLabel;
